import { Component, computed, effect, inject, signal } from '@angular/core';
import { RouteInjection } from '../../../shared/routing/route-injection.class';
import { LvrHeading } from '../../../core/components/heading/heading';
import { IntegrationServiceOffice } from '../../../api/app-types/integration-office.app';
import { TranslocoPipe } from '@jsverse/transloco';
import { MatIcon } from '@angular/material/icon';
import { ContactPointType } from '../../../api/app-types/contact-point.app';
import { LvrPaddingDirective } from '../../../shared/padding/padding.directive';
import { CdkAccordionModule } from '@angular/cdk/accordion';
import { MatButton } from '@angular/material/button';
import { RECORD_MANAGER } from '../../../core/services/record.provide';
import { LvrBorderDirective } from '../../../shared/border/border';

@Component({
	selector: 'lvr-iso-details',
	imports: [LvrHeading, TranslocoPipe, MatIcon, LvrPaddingDirective, CdkAccordionModule, MatButton, LvrBorderDirective],
	templateUrl: './iso-details.html',
	styleUrl: './iso-details.scss',
})
export class IsoDetails extends RouteInjection {
	private readonly recordManager = inject(RECORD_MANAGER);
	private title = signal<string>('');
	public readonly iso = this.resolveDataAsSignal<IntegrationServiceOffice>('iso');

	public readonly preferredCommunicationWay = computed(() => {
		const i = this.iso();
		const cw = i?.contactPoints.find((cp) => cp.preferredWayOfContact);
		return cw;
	});

	public readonly communicationWays = computed(
		() =>
			this.iso()?.contactPoints.filter((cp) => cp.contactValue !== this.preferredCommunicationWay()?.contactValue) ??
			[],
	);

	public get CONTACT_POINT_TYPE() {
		return ContactPointType;
	}

	public constructor() {
		super();
		effect(() => {
			const i = this.iso();
			if (i?.remark !== this.title()) {
				this.title.set(i?.remark ?? 'Integrationsfachdienst');
				this.recordManager.updateRecordTitleOfActiveRecord(this.title());
			}
		});
	}
}
